var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRumzIconSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star",
    d: "M11.068,195.841l-4.313,2.365a2.017,2.017,0,0,1-2.9-2.192l.826-5.022a2.135,2.135,0,0,0-.574-1.84l-3.5-3.56a2.1,2.1,0,0,1,1.109-3.548l4.831-.732a2.008,2.008,0,0,0,1.5-1.14l2.157-4.56a1.966,1.966,0,0,1,3.587,0l2.157,4.56a2.008,2.008,0,0,0,1.506,1.14l4.831.732a2.1,2.1,0,0,1,1.108,3.548l-3.5,3.56a2.134,2.134,0,0,0-.573,1.84l.826,5.022a2.017,2.017,0,0,1-2.9,2.192l-4.312-2.365a1.93,1.93,0,0,0-1.864,0",
    transform: "translate(0 -174.451)",
    fill: "#E65847"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRumzIconSelected);
export default __webpack_public_path__ + "static/media/RumzIconSelected.0cc6b2aa9a95f6a62d4a299eb6684aad.svg";
export { ForwardRef as ReactComponent };